import React from 'react';
import { useSelector } from 'react-redux';

import CharacterProfileImage from '@evdy/web-core/dist/components/shared/elements/CharacterProfileImage';
import { formatTime } from '@evdy/web-core/dist/lib/utils';

import styles from './DecedentHeaderBar.module.scss';

const {
  'decedent-header-bar': decedentHeaderBarClass,
  'decedent-info': decedentInfoClass,
  'decedent-name': decedentNameClass,
  'decedent-bar-content': decedentBarContentClass,
  //<CharacterProfileImg /> custom styles for community
  'char-profile-img-wrapper': decedentCharImgWrapperClass,
  'char-profile-img': charProfileImgClass,
  'char-profile-no-img': charProfileNoImgClass,
  'char-profile-font': charProfileFontClass
} = styles;

const DecedentHeaderBar = ({ decedentBarContent = () => {} }) => {
  const { decedentDetails } = useSelector(({ webCommunity }) => ({
    decedentDetails: webCommunity.decedentDetails.data
  }));
  const { image, dateOfBirth, dateOfDeath, displayName, name } = decedentDetails;

  const formattedDateOfBirth = formatTime(dateOfBirth, 'YYYY');
  const formattedDateOfDeath = formatTime(dateOfDeath, 'YYYY');
  const missingDodAndDob = !dateOfBirth && !dateOfDeath;

  //format strings
  const formattedDates = missingDodAndDob
    ? '' //No Dates Provided
    : !dateOfDeath
    ? `Born ${formattedDateOfBirth}` //No Birth Date Provided
    : !dateOfBirth
    ? `Passed ${formattedDateOfDeath}` //No Death Date Provided
    : `${formattedDateOfBirth} - ${formattedDateOfDeath}`; //Both Dates Provided

  return (
    <div className={decedentHeaderBarClass}>
      <CharacterProfileImage
        {...{ name, image }}
        customClasses={[decedentCharImgWrapperClass]}
        customProfileImgClasses={[charProfileImgClass]}
        customClassNoImg={[charProfileNoImgClass]}
        customClassFont={[charProfileFontClass]}
      />
      <div className={decedentInfoClass}>
        <p className={decedentNameClass}>{displayName}</p>
        <p>{formattedDates}</p>
      </div>
      <div className={decedentBarContentClass}>{decedentBarContent()}</div>
    </div>
  );
};

export default DecedentHeaderBar;
